// extracted by mini-css-extract-plugin
export default {"message":"styles__message--SdLi3","json":"styles__json--UqBWy","json-value":"styles__json-value--0Pylu"};